import { useCallback } from 'react';

import { useLanguage } from '../../contexts/language';
import { useNoteSaves } from '../../contexts/note-saves';
import { notesUnsaved, useSignOut } from '../../hooks/sign-out';

import styles from './style.module.css';

// Signing out from inside the app, on Profile & settings; the top bar does
// not offer it. While it runs it cannot be pressed again; when it fails, the
// reason shows under it and pressing it again retries. On success the router
// replaces the whole app with the sign-in screen, so there is nothing to
// reset.
//
// Whether it runs and why it stopped are the note saves' shared sign-out
// transition (#134), not this screen's: leaving Settings and coming back
// shows the same state. A clinician's note that could not be saved holds the
// sign-out back (#132): pressing it again tries the note again, and the
// message offers to sign out without it, so a note the service keeps
// refusing never locks anyone in.
export function SignOut() {
  const { text, translate } = useLanguage();
  const { signingOut, signOutFailure } = useNoteSaves();
  const signOut = useSignOut();

  // The reason is shown from the shared transition, so the rejection itself
  // needs nothing more here.
  const run = useCallback(function(discard) {
    return signOut({ discard }).catch(function() {});
  }, [ signOut ]);

  const onClick = useCallback(function() {
    return run(false);
  }, [ run ]);

  const onDiscard = useCallback(function() {
    return run(true);
  }, [ run ]);

  let message = null;

  if (signingOut === false && signOutFailure != null) {
    let discard = null;

    if (signOutFailure === notesUnsaved) {
      discard = <button className={ styles.discard } type='button' onClick={ onDiscard }>{ text.signOutWithoutNote }</button>;
    }

    message = (
      <div className={ styles.error } role='alert'>
        <span>{ translate(signOutFailure) }</span>

        { discard }
      </div>
    );
  }

  return (
    <div className={ styles.signOut }>
      <button className={ styles.button } type='button' onClick={ onClick } disabled={ signingOut }>{ text.signOut }</button>

      { message }
    </div>
  );
}
